import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { AREA, WHATSAPP_URL, WhatsAppIcon } from "@/lib/site";
import { BeforeAfterSlider } from "@/components/landing/BeforeAfter";

export const Hero = () => (
    <section id="top" className="border-b-2 border-ink bg-cream">
        <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 lg:grid-cols-2 lg:items-center lg:py-24">
            <motion.div
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
            >
                <p className="mb-4 inline-block border-2 border-ink bg-white px-3 py-1 text-xs font-bold uppercase tracking-widest">
                    Ripristino fari a domicilio — {AREA}
                </p>
                <h1 className="headline-display text-5xl font-bold sm:text-6xl lg:text-7xl">
                    Fari opachi?
                    <span className="block text-royal">Ridai luce</span>
                    alla tua auto.
                </h1>
                <p className="mt-6 max-w-xl text-base font-medium leading-relaxed text-ink/80 md:text-lg">
                    Ripristino professionale dei fari direttamente a domicilio:
                    niente officina, veniamo noi da te. Contattaci su WhatsApp,
                    inviaci alcune foto e valutiamo insieme il tuo caso.
                </p>
                <p className="mt-4 max-w-xl text-sm font-medium leading-relaxed text-ink/70 md:text-base">
                    Lavoriamo dove si trova la tua auto, a Milano Est e
                    nell'hinterland. Il trattamento recupera trasparenza ed
                    estetica del policarbonato esterno e si conclude con una
                    protezione nanotecnologica, per un risultato che dura nel
                    tempo.
                </p>
                <div className="mt-8 flex flex-col gap-4 sm:flex-row">
                    <a
                        href={WHATSAPP_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="hero-whatsapp-btn"
                        className="flex items-center justify-center gap-2 border-2 border-ink bg-wa px-6 py-4 font-display text-lg font-semibold uppercase tracking-tight text-ink transition-[transform,box-shadow] duration-150 hover:-translate-y-1 hover:shadow-print"
                    >
                        <WhatsAppIcon className="h-5 w-5" />
                        Preventivo gratuito
                    </a>
                    <a
                        href="#prima-dopo"
                        data-testid="hero-results-btn"
                        className="flex items-center justify-center gap-2 border-2 border-ink bg-white px-6 py-4 font-display text-lg font-semibold uppercase tracking-tight text-ink transition-[transform,box-shadow] duration-150 hover:-translate-y-1 hover:shadow-print"
                    >
                        Guarda il prima/dopo
                        <ArrowDown className="h-5 w-5" />
                    </a>
                </div>
                <p className="mt-4 text-xs font-bold uppercase tracking-widest text-ink/60">
                    Preventivi gratuiti · Trattamenti da 59€
                </p>
            </motion.div>

            <motion.figure
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.15 }}
                className="border-2 border-ink bg-ink shadow-print"
            >
                <BeforeAfterSlider
                    before="/assets/lavori/argento-prima.jpg"
                    after="/assets/lavori/argento-dopo.jpg"
                    altBefore="Faro opaco e ingiallito prima del ripristino"
                    altAfter="Lo stesso faro trasparente e brillante dopo il ripristino"
                    framed={false}
                />
                <figcaption className="flex items-center justify-between bg-ink px-4 py-2 text-xs font-bold uppercase tracking-widest text-cream">
                    <span>Lavoro Clear Lens Milano</span>
                    <span className="text-wa">Trascina il cursore</span>
                </figcaption>
            </motion.figure>
        </div>
    </section>
);
